import { render, staticRenderFns } from "./attachment-card.vue?vue&type=template&id=73e78ef3&scoped=true&"
import script from "./attachment-card.vue?vue&type=script&lang=js&"
export * from "./attachment-card.vue?vue&type=script&lang=js&"
import style0 from "./attachment-card.vue?vue&type=style&index=0&id=73e78ef3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e78ef3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
